/*
 * View-model types for the subscription widget.
 *
 * The domain types it renders — `SubscriptionTier`, `FacilitySubscriptionUsage`
 * and `resolveSubscriptionTier` — live in `@umss/shared/data-access`, since the
 * data layer needs them too and must not depend on UI.
 */

/** A labelled position on the widget's shift scale. */
export interface SubscriptionWidgetScaleMark {
  /** Shift count the mark sits at. */
  value: number;
  /** Horizontal offset along the track, as a percentage of its width. */
  percent: number;
}

/** A per-tier price caption sitting beneath the band it labels. */
export interface SubscriptionWidgetTierCaption {
  /** Flat monthly price for the tier. */
  price: number;
  /** Width of the band being labelled, as a percentage of the track. */
  widthPercent: number;
}
